const SENSITIVE_KEYS = ['code', 'access_token', 'id_token', 'client_info', 'session_state', 'state'];
export const sanitizeUri = (uri) => {
    uri = stripSensitiveFragments(uri);
    return redactSensitiveQueryParams(uri);
};
export const redactPageViewUri = (_uri) => 'REDACTED';
export const redactQueryParam = (uri, paramName) => {
    try {
        const methodMatch = uri.match(/^([A-Z]+\s+)(.*)/);
        const prefix = methodMatch ? methodMatch[1] : '';
        const urlPart = methodMatch ? methodMatch[2] : uri;
        const url = new URL(urlPart);
        if (url.searchParams.has(paramName)) {
            url.searchParams.set(paramName, 'REDACTED');
        }
        return prefix + url.toString();
    }
    catch {
        return uri;
    }
};
const stripSensitiveFragments = (uri) => {
    try {
        const hashIndex = uri.indexOf('#');
        if (hashIndex === -1) {
            return uri;
        }
        const baseUrl = uri.substring(0, hashIndex);
        const hash = uri.substring(hashIndex + 1);
        const params = new URLSearchParams(hash);
        let modified = false;
        for (const key of SENSITIVE_KEYS) {
            if (params.has(key)) {
                params.set(key, 'REDACTED');
                modified = true;
            }
        }
        if (!modified) {
            return uri;
        }
        const remaining = params.toString();
        return remaining ? `${baseUrl}#${remaining}` : baseUrl;
    }
    catch {
        const hashIndex = uri.indexOf('#');
        return hashIndex !== -1 ? uri.substring(0, hashIndex) : uri;
    }
};
const redactSensitiveQueryParams = (uri) => {
    try {
        const url = new URL(uri);
        let modified = false;
        for (const key of SENSITIVE_KEYS) {
            if (url.searchParams.has(key)) {
                url.searchParams.set(key, 'REDACTED');
                modified = true;
            }
        }
        return modified ? url.toString() : uri;
    }
    catch {
        return uri;
    }
};
